// Persists email + password to localStorage so the login screen can
// auto-fill (and optionally auto-submit) on the next visit. Mirrors the
// Flutter app's SharedPreferences-based "Se souvenir de moi" behaviour.
//
// Security tradeoff: storing the password client-side in plaintext is a real
// risk if the device is shared. We accept it to match Flutter's UX. The
// Firebase session token persists in localStorage anyway via
// browserLocalPersistence, so the only added exposure here is the password
// itself (which the attacker would already implicitly hold via the session).

const KEY_FLAG = 'remember_me';
const KEY_EMAIL = 'remember_email';
const KEY_PASSWORD = 'remember_password';

export type RememberedCreds = { email: string; password: string };

export function readRememberFlag(): boolean {
  return localStorage.getItem(KEY_FLAG) === 'true';
}

export function readRememberedCreds(): RememberedCreds | null {
  if (!readRememberFlag()) return null;
  const email = localStorage.getItem(KEY_EMAIL) ?? '';
  const password = localStorage.getItem(KEY_PASSWORD) ?? '';
  if (!email || !password) return null;
  return { email, password };
}

export function saveRememberedCreds(creds: RememberedCreds): void {
  localStorage.setItem(KEY_FLAG, 'true');
  localStorage.setItem(KEY_EMAIL, creds.email);
  localStorage.setItem(KEY_PASSWORD, creds.password);
}

export function clearRememberedCreds(): void {
  localStorage.setItem(KEY_FLAG, 'false');
  localStorage.removeItem(KEY_EMAIL);
  localStorage.removeItem(KEY_PASSWORD);
}
